import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import AdvertiserList from 'Components/Presentation/Advertisers/AdvertiserList';
import AdvertiserEditContainer from './Edit';

import AllAdvertisersQuery from 'GraphQueries/Advertisers/AllQuery';
import NewAdvertiserMutation from 'GraphQueries/Advertisers/NewMutation';
import NewAdvertiserSubscription from 'GraphQueries/Advertisers/NewSubscription';
import DeleteAdvertiserMutation from 'GraphQueries/Advertisers/DeleteMutation';
import DeleteAdvertiserSubscription from 'GraphQueries/Advertisers/DeleteSubscription';

class AdvertiserIndexContainer extends React.Component {

    static defaultProps = {
        advertisers: [],
        loading: false
    }

    state = {
        advertiser: null,
        saving: false,
        processing: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    navigateWithData = (uri, advertiser) => {
        const { history } = this.props;
        this.setState({ advertiser });
        history.push(uri);
    }

    saveAdvertiser = advertiser => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(advertiser).then(x => {
            this.setState({ saving: false });
            this.navigateWithData(`/organisations/advertisers/${advertiser.id}/manage/settings`, advertiser);
            onAlert('success', `Successfully created advertiser: ${advertiser.name}`);
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to create advertisers, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: true });
        })
    }

    deleteAdvertiser = async (advertiser) => {
        const { onAlert, onDelete } = this.props;
        this.setState({ saving: true });
        onDelete(advertiser.id).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully deleted advertiser: ${advertiser.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to delete advertisers, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    loadAdvertisers = async(advertisers) => {        
        const { onLoadMore } = this.props;        
        this.setState({ processing: true });
        onLoadMore(advertisers).then(x => {
            this.setState({ processing: false });
        });
    }

    render() {
        const { advertisers, loading } = this.props;
        const { advertiser, saving, processing } = this.state;
        return (
            <React.Fragment>
                <Route path='/organisations/advertisers' exact render={props => {
                    return (
                        <AdvertiserList {...props} loading={loading || saving} processing={processing} onEdit={this.navigateWithData} advertisers={advertisers}
                            onAdvertiserAdded={this.saveAdvertiser} onAdvertiserRemoved={this.deleteAdvertiser} onLoadAdvertisers={this.loadAdvertisers} />
                    )}
                } />
                <Route path="/organisations/advertisers/list" render={props => {
                    return (
                        <AdvertiserList {...props} loading={loading || saving} processing={processing} onEdit={this.navigateWithData} advertisers={advertisers}
                            onAdvertiserAdded={this.saveAdvertiser} onAdvertiserRemoved={this.deleteAdvertiser} onLoadAdvertisers={this.loadAdvertisers} />
                    )}
                } />
                <Route path="/organisations/advertisers/:id/manage" render={routeProps => {
                    return (
                        <AdvertiserEditContainer {...this.props} {...routeProps}  advertiser={advertiser} />
                    )}
                } />
            </React.Fragment >
        );
    }
}

export default compose(
    graphql(AllAdvertisersQuery(), {
        props: ({ data: { listAdvertisers, loading, subscribeToMore, fetchMore } }) => ({
            advertisers: listAdvertisers,
            loading: loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewAdvertiserSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateAdvertiser } } }) => ({
                        ...prev,
                        listAdvertisers: { items: [onCreateAdvertiser, ...prev.listAdvertisers.items.filter(item => item.id !== onCreateAdvertiser.id)], __typename: 'AdvertiserConnection' }
                    })
                });
                subscribeToMore({
                    document: DeleteAdvertiserSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteAdvertiser } } }) => ({
                        ...prev,
                        listAdvertisers: { items: [...prev.listAdvertisers.items.filter(item => item.id !== onDeleteAdvertiser.id)], __typename: 'AdvertiserConnection' }
                    })
                });
            },
            onLoadMore: params => {
                return fetchMore({
                    variables: { nextToken: listAdvertisers.nextToken },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newAdvertisers = fetchMoreResult.listAdvertisers.items;
                        const token = fetchMoreResult.listAdvertisers.nextToken;

                        return newAdvertisers.length
                            ? {
                                listAdvertisers: {
                                    __typename: 'AdvertiserConnection',
                                    items: [...previousResult.listAdvertisers.items, ...newAdvertisers],
                                    nextToken: token
                                }
                            }
                            : previousResult;
                    }
                }); 
            }
        })
    }),
    graphql(NewAdvertiserMutation(), { props: ({ mutate }) => ({ onAdd: input => mutate({ variables: { input } }) }) }), 
    graphql(DeleteAdvertiserMutation(), { props: ({ mutate }) => ({ onDelete: id => mutate({ variables: { id } }) }) })
)(AdvertiserIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Advertisers/Index.js